{
  "$description": "HopEx design tokens v0.2 (Phase 2 rebuild). W3C Design Tokens format. Source for packages/tokens -> CSS variables (--hx-*). Dark is the brand default; light per OD-11, rebuilt 2026-10-02 (ivory stone, graphite, champagne; UI UX Pro Max luxury profile, see docs/design/UIUX_PRO_MAX_HOPEX.md). Contrast enforced by tokens.test.ts.",
  "brand": {
    "gold": {
      "$type": "color",
      "$value": "#F0B90B",
      "$description": "Approved primary gold. Fill/CTA/brand. Never text on light surfaces."
    },
    "goldSoft": {
      "$type": "color",
      "$value": "#D8B45A",
      "$description": "Approved soft gold. Premium detail, secondary accent on dark."
    },
    "ink": {
      "$type": "color",
      "$value": "#0B0B0D",
      "$description": "Approved background; also text on gold fills (10.9:1)."
    }
  },
  "color": {
    "dark": {
      "bg": {
        "$type": "color",
        "$value": "#0B0B0D"
      },
      "bgDeep": {
        "$type": "color",
        "$value": "#050506",
        "$description": "Landing canvas / page edge"
      },
      "surface1": {
        "$type": "color",
        "$value": "#151518",
        "$description": "Cards, rows"
      },
      "surface2": {
        "$type": "color",
        "$value": "#1F2024",
        "$description": "Elevated: sheets, dialogs, inputs"
      },
      "surface3": {
        "$type": "color",
        "$value": "#2A2B30",
        "$description": "Hover/pressed on elevated"
      },
      "border": {
        "$type": "color",
        "$value": "rgba(255,255,255,0.07)"
      },
      "borderStrong": {
        "$type": "color",
        "$value": "rgba(255,255,255,0.12)"
      },
      "textPrimary": {
        "$type": "color",
        "$value": "#FFFFFF",
        "$description": "19.7:1 on bg"
      },
      "textSecondary": {
        "$type": "color",
        "$value": "#A8A8AE",
        "$description": "8.3:1 on bg, 6.9:1 on surface2"
      },
      "textTertiary": {
        "$type": "color",
        "$value": "#8A8A92",
        "$description": "Meta text; 4.75:1 on surface2 (darkest pairing)"
      },
      "accent": {
        "$type": "color",
        "$value": "#F0B90B"
      },
      "accentText": {
        "$type": "color",
        "$value": "#F0B90B",
        "$description": "10.9:1 on bg"
      },
      "accentSoft": {
        "$type": "color",
        "$value": "#D8B45A"
      },
      "accentTint": {
        "$type": "color",
        "$value": "rgba(240,185,11,0.12)"
      },
      "onAccent": {
        "$type": "color",
        "$value": "#0B0B0D"
      },
      "primary": {
        "$type": "color",
        "$value": "#F0B90B",
        "$description": "Primary action fill (brand gold on dark)"
      },
      "onPrimary": {
        "$type": "color",
        "$value": "#0B0B0D",
        "$description": "Text on primary (10.9:1)"
      },
      "positive": {
        "$type": "color",
        "$value": "#2EB67D",
        "$description": "7.0:1 on surface1"
      },
      "positiveTint": {
        "$type": "color",
        "$value": "rgba(46,182,125,0.12)"
      },
      "negative": {
        "$type": "color",
        "$value": "#F6465D",
        "$description": "5.2:1 on surface1"
      },
      "negativeTint": {
        "$type": "color",
        "$value": "rgba(246,70,93,0.12)"
      },
      "pending": {
        "$type": "color",
        "$value": "#D8B45A"
      },
      "info": {
        "$type": "color",
        "$value": "#8FA8D8"
      },
      "focusRing": {
        "$type": "color",
        "$value": "#F0B90B"
      },
      "scrim": {
        "$type": "color",
        "$value": "rgba(0,0,0,0.55)"
      },
      "glow": {
        "$type": "color",
        "$value": "rgba(240,185,11,0.16)"
      }
    },
    "light": {
      "bg": {
        "$type": "color",
        "$value": "#F2EEE6",
        "$description": "Ivory stone ground — never pure white"
      },
      "bgDeep": {
        "$type": "color",
        "$value": "#E8E2D6",
        "$description": "Warm stone: footer, sidebar, bands"
      },
      "surface1": {
        "$type": "color",
        "$value": "#FAF8F3",
        "$description": "Paper: cards, rows"
      },
      "surface2": {
        "$type": "color",
        "$value": "#FDFCF9",
        "$description": "Raised: sheets, dialogs, inputs (separated by border + shadow)"
      },
      "surface3": {
        "$type": "color",
        "$value": "#E9E4DA",
        "$description": "Hover / pressed / sunken wells"
      },
      "border": {
        "$type": "color",
        "$value": "rgba(28,25,23,0.11)"
      },
      "borderStrong": {
        "$type": "color",
        "$value": "rgba(28,25,23,0.20)"
      },
      "textPrimary": {
        "$type": "color",
        "$value": "#1C1917",
        "$description": "Graphite; 15.1:1 on bg"
      },
      "textSecondary": {
        "$type": "color",
        "$value": "#4A4540",
        "$description": "8.2:1 on bg"
      },
      "textTertiary": {
        "$type": "color",
        "$value": "#655E56",
        "$description": "Meta text; 4.95:1 on bgDeep (darkest pairing)"
      },
      "accent": {
        "$type": "color",
        "$value": "#D8B45A",
        "$description": "Champagne gold fill (approved soft gold); ink text 9.9:1. Fills only"
      },
      "accentText": {
        "$type": "color",
        "$value": "#7A5A12",
        "$description": "Old gold for text and hairlines; 5.5:1 on bg, 4.9:1 on bgDeep"
      },
      "accentSoft": {
        "$type": "color",
        "$value": "#B8954A",
        "$description": "Decorative champagne (lines, gradients) — not for text"
      },
      "accentTint": {
        "$type": "color",
        "$value": "rgba(184,149,74,0.14)"
      },
      "onAccent": {
        "$type": "color",
        "$value": "#0B0B0D"
      },
      "primary": {
        "$type": "color",
        "$value": "#1C1917",
        "$description": "Primary action fill: graphite (no yellow-on-ivory)"
      },
      "onPrimary": {
        "$type": "color",
        "$value": "#F7F3EA",
        "$description": "Ivory on graphite 15.8:1"
      },
      "positive": {
        "$type": "color",
        "$value": "#0F6B40",
        "$description": "5.6:1 on bg"
      },
      "positiveTint": {
        "$type": "color",
        "$value": "rgba(15,107,64,0.10)"
      },
      "negative": {
        "$type": "color",
        "$value": "#B4233A",
        "$description": "5.6:1 on bg"
      },
      "negativeTint": {
        "$type": "color",
        "$value": "rgba(180,35,58,0.08)"
      },
      "pending": {
        "$type": "color",
        "$value": "#7A5A12"
      },
      "info": {
        "$type": "color",
        "$value": "#2F5DA8"
      },
      "focusRing": {
        "$type": "color",
        "$value": "#1C1917"
      },
      "scrim": {
        "$type": "color",
        "$value": "rgba(28,25,23,0.42)"
      },
      "glow": {
        "$type": "color",
        "$value": "rgba(216,180,90,0.22)"
      }
    }
  },
  "font": {
    "family": {
      "persian": {
        "$type": "fontFamily",
        "$value": ["Vazirmatn", "Tahoma", "sans-serif"],
        "$description": "Self-hosted variable woff2, OFL"
      },
      "numeric": {
        "$type": "fontFamily",
        "$value": ["Vazirmatn", "Inter", "sans-serif"],
        "$description": "Latin digits; tabular figures required — use Inter (OFL) for amounts if Vazirmatn lacks tnum (verify Phase 1)"
      },
      "mono": {
        "$type": "fontFamily",
        "$value": ["JetBrains Mono", "ui-monospace", "monospace"],
        "$description": "Addresses, TXIDs, IBAN, IDs (OFL)"
      }
    },
    "size": {
      "caption": {
        "$type": "dimension",
        "$value": "12px"
      },
      "small": {
        "$type": "dimension",
        "$value": "13px"
      },
      "body": {
        "$type": "dimension",
        "$value": "14px"
      },
      "bodyLg": {
        "$type": "dimension",
        "$value": "16px"
      },
      "title": {
        "$type": "dimension",
        "$value": "18px"
      },
      "h3": {
        "$type": "dimension",
        "$value": "20px"
      },
      "h2": {
        "$type": "dimension",
        "$value": "24px"
      },
      "h1": {
        "$type": "dimension",
        "$value": "30px"
      },
      "balance": {
        "$type": "dimension",
        "$value": "30px",
        "$description": "Mobile hero balance; desktop 40px"
      },
      "displayLanding": {
        "$type": "dimension",
        "$value": "clamp(40px, 7vw, 104px)"
      }
    },
    "weight": {
      "regular": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "heavy": 800
    },
    "lineHeight": {
      "tight": 1.2,
      "normal": 1.6,
      "persianBody": 1.8
    }
  },
  "space": {
    "0": "0",
    "0.5": "2px",
    "1": "4px",
    "1.5": "6px",
    "2": "8px",
    "3": "12px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "8": "32px",
    "10": "40px",
    "12": "48px",
    "16": "64px",
    "20": "80px",
    "24": "96px",
    "32": "128px"
  },
  "radius": {
    "xs": "6px",
    "sm": "10px",
    "md": "14px",
    "lg": "18px",
    "xl": "22px",
    "sheet": "26px",
    "pill": "999px"
  },
  "shadow": {
    "dark": {
      "float": "0 40px 80px -20px rgba(0,0,0,0.70)",
      "cta": "0 12px 24px -10px rgba(240,185,11,0.55)",
      "card": "none"
    },
    "light": {
      "float": "0 40px 80px -32px rgba(28,25,23,0.30), 0 2px 6px rgba(28,25,23,0.06)",
      "cta": "0 12px 24px -12px rgba(28,25,23,0.45)",
      "card": "0 1px 0 rgba(255,255,255,0.7) inset, 0 1px 2px rgba(28,25,23,0.05), 0 14px 32px -20px rgba(28,25,23,0.22)"
    }
  },
  "breakpoint": {
    "xs": "360px",
    "sm": "480px",
    "md": "768px",
    "lg": "1024px",
    "xl": "1280px",
    "2xl": "1536px"
  },
  "layout": {
    "appMaxWidth": "1440px",
    "contentMaxWidth": "1200px",
    "readingMaxWidth": "720px",
    "sidebarWidth": "264px",
    "sidebarCollapsed": "76px",
    "topBarHeight": "64px",
    "bottomNavHeight": "72px",
    "touchTargetMin": "44px"
  },
  "motion": {
    "duration": {
      "instant": "80ms",
      "fast": "140ms",
      "base": "220ms",
      "slow": "320ms",
      "sheet": "380ms",
      "count": "900ms"
    },
    "easing": {
      "standard": "cubic-bezier(0.2, 0.8, 0.2, 1)",
      "enter": "cubic-bezier(0.16, 1, 0.3, 1)",
      "exit": "cubic-bezier(0.4, 0, 1, 1)",
      "sheet": "cubic-bezier(0.2, 0.9, 0.25, 1)"
    },
    "spring": {
      "sheet": {
        "stiffness": 420,
        "damping": 40,
        "mass": 1
      },
      "press": {
        "stiffness": 600,
        "damping": 35
      }
    }
  }
}
